import Modal from "react-bootstrap/Modal";
import React, { useState, useContext, useEffect } from "react";

import searchicon from "../../../assets/images/ic_search.svg";
import ic_search_dark from "../../../assets/images/ic_search_dark.svg";

import Dropdown from "react-bootstrap/Dropdown";
import Up_arrow_white from "../../../assets/images/Up_arrow_white.svg";
import downarrow from "../../../assets/images/ic_down_green.svg";
import optionIcon from "../../../assets/images/optionDot.svg";
import { AppContext } from "../../../context/AppContext";
import Moment from "react-moment";
import { BeatLoader } from "react-spinners";

import DarkCross from "../../../assets/images/close_modal.svg";
import LightCross from "../../../assets/images/close_modal_dark.svg";
import ReactPaginate from "react-paginate";
import NoDataFound from "../../ChatAdmin/NodataFound";
import GoodsInvoiceView from "../../../component/Sales/GoodsInvoiceView";
import GoodsPrintView from "../../../component/Sales/GoodsPrintView";
import ApiConfig from "../../../api/ApiConfig";
import {
  PostCallWithAuthToken,
  postMultipartWithAuthCallWithErrorResponse,
} from "../../../api/ApiServices";
import FileSaver from "file-saver";
// import { notify, notifySuccess } from "../../toaster/notify";
import ReportTabs from "../../../sharedComponent/ReportTabs";
import { positions } from "@mui/system";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import isoWeek from "dayjs/plugin/isoWeek";

dayjs.extend(isBetween);
dayjs.extend(isoWeek);

const SalseReport = (props) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [innermenu, setinnermenu] = useState(false);
  const [innermenu2, setinnermenu2] = useState(false);
  const [active] = useState("");
  const [date, setDate] = useState(false);
  const [company, setCompany] = useState(false);
  const [option, setOption] = useState(false);
  const [salesReport, setSalesReport] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [usersPerPage, setUsersPerPage] = useState(5);
  const [FilteredReports, setFilteredReports] = useState([]);

  const [reportPayLoad, setReportPayLoad] = useState({
    payMode: "All",
  });
  console.log("reportPayLoad,", reportPayLoad);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  console.log("fromDate,", fromDate);
  console.log("toDate,", toDate);

  const { sidebar, Dark, get, appSettings } = useContext(AppContext);

  const innerlist = () => {
    setinnermenu(!innermenu);
    setinnermenu2(false);
  };
  const chnagviwe = () => {
    setinnermenu2(!innermenu2);
    setinnermenu(false);
  };
  const handeldate = () => {
    setDate(true);
  };
  const dateclose = () => {
    setDate(false);
  };
  const applyfilter = () => {
    console.log("applyfilter");
  };
  const compantShow = () => {
    setCompany(true);
  };
  const companyClose = () => {
    setCompany(false);
    console.log("companyClose");
  };
  const optionshow = () => {
    setOption(!option);
  };

  const [viewType, setViewType] = useState(null);
  const toggleMenu = () => {
    setinnermenu2(!innermenu2);
  };

  // const parseDate = (dateStr) => {
  //   const [day, month, year] = dateStr.split("/"); // Split into day, month, and year
  //   return `${year}-${month}-${day}`; // Return the ISO format (YYYY-MM-DD)
  // };

  // const filterReports = () => {
  //   if (fromDate && toDate) {
  //     const filteredData = salesReport.filter((report) => {
  //       const reportDate = dayjs(parseDate(report.date)); // Convert date string to dayjs
  //       return reportDate.isBetween(fromDate, toDate, null, "[]"); // Include the range
  //     });

  //     setFilteredReports(filteredData);
  //   } else {
  //     setFilteredReports(salesReport); // If no date range, return all reports
  //   }
  // };
  // useEffect(() => {
  //   filterReports();
  // }, [fromDate, toDate, salesReport]);

  const [previewTaxInvoiceData, setPreviewTaxInvoiceData] = useState({});
  const [isView, setIsView] = useState(false);
  const [print, setPrint] = useState(false);
  const [printModal, setPrintModal] = useState(false);
  const [previewLoader, setPreviewLoader] = useState(false);

  const today = dayjs();

  const getTaxInvoiceData = async (invoiceId, actionType) => {
    // invoiceId && invoiceId && setPreviewLoader(true);
    try {
      const res = await get(
        `${ApiConfig.GET_SALES_INVOICE_TAX_DATA}/${invoiceId}`
      );
      console.log("res,,,", res);
      const { data, success } = res;
      if (success && data) {
        setPreviewTaxInvoiceData(data);
        if (actionType.includes("view")) {
          setIsView(true);
        } else if (actionType.includes("print")) {
          setPrint(true);
        }
      }
    } catch (error) {
      console.log("catch error,", error);
    }
    // simpleGetCallWithToken(
    //   ApiConfig.GET_SALES_INVOICE_TAX_DATA + `/${invoiceId}`
    // )
    //   .then((res) => {
    //     if (res.data !== null) {
    //       setPreviewTaxInvoiceData(res.data);
    //       if (actionType.includes("view")) {
    //         setIsView(true);
    //       } else if (actionType.includes("print")) {
    //         setPrint(true);
    //       }
    //     }
    //   })
    //   .catch((err) => console.log(err))
    //   .finally(() => {
    //     setPreviewLoader(false);
    //   });
    // Filter function
  };

  const exportSalesReport = () => {
    // setLoading(true);
    PostCallWithAuthToken(
      ApiConfig.DOWNLOAD_EXCEL_SALES_REPORT,
      JSON.stringify(reportPayLoad)
    )
      .then((res) => {
        console.log(res.json.excelBase64);

        const byteCharacters = atob(res.json.excelBase64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        // Save the Blob as a file
        FileSaver.saveAs(blob, "SalesReport.xlsx");
        // if(res && res.success){
        // FileSaver.saveAs(
        // "data:" + res.excelBase64 + ";base64," + "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        // "Sales Goods List"
        // );
        // notifySuccess("Excel sheet download successfully");

        //setSalesReport();
        //setLoading();
      })
      .catch((err) => console.log("Catch error from downLoadExcelFile,", err));
  };

  // Filter by Daily, weekly, quartly, semi-anually, anually

  const getDateRange = (viewType) => {
    let fromDate;
    let toDate;

    switch (viewType) {
      case "Daily":
        const today = dayjs();
        const startOfToday = today.startOf("day");
        const endOfToday = today.endOf("day");
        setReportPayLoad({
          ...reportPayLoad,
          fromDate: startOfToday,
          toDate: endOfToday,
        });
        break;

      case "Weekly":
        const today2 = dayjs();
        const toDate2 = today2.endOf("day");
        const fromDate2 = today2.subtract(5, "day").startOf("day");
        setReportPayLoad({
          ...reportPayLoad,
          fromDate: fromDate2,
          toDate: toDate2,
        });
        break;

      case "Quarterly":
        const currentDate2 = dayjs();
        const fromDate4 = currentDate2.subtract(4, "month");
        const toDate4 = currentDate2.endOf("day");

        setReportPayLoad({
          ...reportPayLoad,
          fromDate: fromDate4,
          toDate: toDate4,
        });
        break;

      case "Semi-Annually":
        const currentDate = dayjs();
        const fromDate = currentDate.subtract(6, "month");
        const toDate = currentDate.endOf("day");

        setReportPayLoad({
          ...reportPayLoad,
          fromDate,
          toDate,
        });
        break;

      case "Annually":
        const today3 = dayjs();
        const fromDate3 = today3.subtract(1, "year");
        const toDate3 = today3;
        setReportPayLoad({
          ...reportPayLoad,
          fromDate: fromDate3,
          toDate: toDate3,
        });
        break;

      default:
        setReportPayLoad({
          ...reportPayLoad,
          fromDate: null,
          toDate: null,
        });
        break;
    }

    return { fromDate, toDate };
  };

  const startIndex = currentPage * usersPerPage;
  const endIndex = startIndex + parseInt(usersPerPage);

  const changePage = ({ selected }) => {
    setCurrentPage(selected);
  };

  const pageSizeHandler = (e) => {
    setUsersPerPage(e.target.value);
    setCurrentPage(0);
  };

  const pageCount = Math.ceil(salesReport?.length / usersPerPage);

  const searchedDataPageCounts =
    salesReport &&
    salesReport.length &&
    salesReport.filter((item) =>
      item.particular?.toLowerCase().includes(searchValue)
    );

  const displayInvoices =
    salesReport &&
    salesReport?.slice(startIndex, endIndex).map((report, index) => {
      return (
        <tr className="table-row-custom salesList">
          <td>{startIndex + index + 1}</td>
          <td>
            <Moment format="DD/MM/YYYY">{report.invoiceDate}</Moment>
          </td>

          <td>{report.particular}</td>
          <td>{report.invoiceType}</td>

          {/* Static data****************** */}
          <Dropdown className="DropdownMenoReport ">
            <Dropdown.Toggle
              variant="success"
              id="dropdown-basic"
              className="threedotOption "
              style={{ backgroundColor: "transparent" }}
            >
              <td>{report.invoiceNo}</td>
            </Dropdown.Toggle>

            <Dropdown.Menu
              className="dropdownMeno22"
              style={{ marginLeft: "60px", marginTop: "-40px" }}
            >
              <ul className="dropdownmenulist22">
                <li
                  onClick={() => {
                    // optionshow();
                    getTaxInvoiceData(report.id, "print");
                  }}
                >
                  Print
                </li>
                <li
                  onClick={() => {
                    getTaxInvoiceData(report.id, "view");
                    // optionshow()
                  }}
                >
                  View
                </li>
                <li>Download</li>
              </ul>
            </Dropdown.Menu>
          </Dropdown>
          {appSettings && appSettings.isGSTApplicable && (
            <td>{report.gstNo ? report.gstNo : "-"}</td>
          )}
          <td>₹{report.grossTotal}</td>
          <td>₹{report.roundOffAmt}</td>
          {appSettings && appSettings.isGSTApplicable && (
            <td>₹{report.gstFivePerTaxableAmt}</td>
          )}
          {appSettings && appSettings.isGSTApplicable && (
            <td>₹{report.cgstTwoAndHalfPerAmt}</td>
          )}
          {appSettings && appSettings.isGSTApplicable && (
            <td>₹{report.sgstTwoAndHalfPerAmt}</td>
          )}
          {appSettings && appSettings.isGSTApplicable && (
            <td>₹{report.gstTwelvePerTaxableAmt}</td>
          )}
          {appSettings && appSettings.isGSTApplicable && (
            <td>₹{report.cgstSixPerAmt}</td>
          )}
          {appSettings && appSettings.isGSTApplicable && (
            <td>₹{report.sgstSixPerAmt}</td>
          )}
          {appSettings && appSettings.isGSTApplicable && (
            <td>₹{report.gstEighteenPerTaxableAmt}</td>
          )}
          {appSettings && appSettings.isGSTApplicable && (
            <td>₹{report.cgstNinePerAmt}</td>
          )}
          {appSettings && appSettings.isGSTApplicable && (
            <td>₹{report.sgstNinePerAmt}</td>
          )}
          {appSettings && appSettings.isGSTApplicable && (
            <td>₹{report.gstTwentyEightPerTaxableAmt} </td>
          )}
          {appSettings && appSettings.isGSTApplicable && (
            <td>₹{report.cgstFourteenPerAmt} </td>
          )}
          {appSettings && appSettings.isGSTApplicable && (
            <td>₹{report.sgstFourteenPerAmt} </td>
          )}
          {appSettings && appSettings.isGSTApplicable && (
            <td>₹{report.igstFivePerTaxableAmt}</td>
          )}
          {appSettings && appSettings.isGSTApplicable && (
            <td>₹{report.igstFivePerAmt}</td>
          )}
          {appSettings && appSettings.isGSTApplicable && (
            <td>₹{report.igstTwelvePerTaxableAmt}</td>
          )}
          {appSettings && appSettings.isGSTApplicable && (
            <td>₹{report.igstTwelvePerAmt}</td>
          )}
          {appSettings && appSettings.isGSTApplicable && (
            <td>₹{report.igstEighteenPerTaxableAmt}</td>
          )}
          {appSettings && appSettings.isGSTApplicable && (
            <td>₹{report.igstEighteenPerAmt}</td>
          )}
          {appSettings && appSettings.isGSTApplicable && (
            <td>₹{report.igstTwentyEightPerTaxableAmt}</td>
          )}
          {appSettings && appSettings.isGSTApplicable && (
            <td>₹{report.igstTwentyEightPerAmt}</td>
          )}
          <td>₹{report.otherCharges}</td>
          <td>
            <Dropdown className="DropdownMenoReport ">
              <Dropdown.Toggle
                variant="success"
                id="dropdown-basic"
                className="threedotOption "
              >
                <img src={optionIcon} alt="" />
              </Dropdown.Toggle>

              <Dropdown.Menu className="dropdownMeno22">
                <ul className="dropdownmenulist22">
                  <li
                    onClick={() => {
                      // optionshow();
                      getTaxInvoiceData(report.id, "print");
                    }}
                  >
                    Print
                  </li>
                  <li
                    onClick={() => {
                      optionshow();
                      getTaxInvoiceData(report.id, "view");
                    }}
                  >
                    View
                  </li>
                  <li>Download</li>
                </ul>
              </Dropdown.Menu>
            </Dropdown>

          </td>
        </tr>
      );
    });

  const displaySearchedInvoices =
    salesReport &&
    salesReport
      ?.filter(
        (item) =>
          item.particular &&
          (item.particular.toUpperCase().includes(searchValue.toUpperCase()) ||
            item.particular.toLowerCase().includes(searchValue.toLowerCase()))
      )
      .slice(startIndex, endIndex)
      .map((report, index) => {
        return (
          <tr key={"sdghf" + index} className="table-row-custom salesList">
            <td>{startIndex + index + 1}</td>
            <td>
              <Moment format="DD/MM/YYYY">{report.invoiceDate}</Moment>
            </td>

            <td>{report.particular}</td>
            <td>{report.invoiceType}</td>

            {/* Static data****************** */}
            <Dropdown className="DropdownMenoReport ">
              <Dropdown.Toggle
                variant="success"
                id="dropdown-basic"
                className="threedotOption "
                style={{ backgroundColor: "transparent" }}
              >
                <td>{report.invoiceNo}</td>
              </Dropdown.Toggle>

              <Dropdown.Menu
                className="dropdownMeno22"
                style={{ marginLeft: "60px", marginTop: "-40px" }}
              >
                <ul className="dropdownmenulist22">
                  <li
                    onClick={() => {
                      getTaxInvoiceData(report.id, "print");
                    }}
                  >
                    Print
                  </li>
                  <li
                    onClick={() => {
                      getTaxInvoiceData(report.id, "view");
                      // optionshow()
                    }}
                  >
                    View
                  </li>
                  <li>Download</li>
                </ul>
              </Dropdown.Menu>
            </Dropdown>
            {appSettings && appSettings.isGSTApplicable && (
              <td>{report.gstNo ? report.gstNo : "-"}</td>
            )}
            <td>₹{report.grossTotal}</td>
            <td>₹{report.roundOffAmt}</td>
            {appSettings && appSettings.isGSTApplicable && (
              <td>₹{report.gstFivePerTaxableAmt}</td>
            )}
            {appSettings && appSettings.isGSTApplicable && (
              <td>₹{report.cgstTwoAndHalfPerAmt}</td>
            )}
            {appSettings && appSettings.isGSTApplicable && (
              <td>₹{report.cgstTwoAndHalfPerAmt}</td>
            )}
            {appSettings && appSettings.isGSTApplicable && (
              <td>₹{report.gstTwelvePerTaxableAmt}</td>
            )}
            {appSettings && appSettings.isGSTApplicable && (
              <td>₹{report.cgstSixPerAmt}</td>
            )}
            {appSettings && appSettings.isGSTApplicable && (
              <td>₹{report.sgstSixPerAmt}</td>
            )}
            {appSettings && appSettings.isGSTApplicable && (
              <td>₹{report.gstEighteenPerTaxableAmt}</td>
            )}
            {appSettings && appSettings.isGSTApplicable && (
              <td>₹{report.cgstNinePerAmt}</td>
            )}
            {appSettings && appSettings.isGSTApplicable && (
              <td>₹{report.sgstNinePerAmt}</td>
            )}
            {appSettings && appSettings.isGSTApplicable && (
              <td>₹{report.gstTwentyEightPerTaxableAmt} </td>
            )}
            {appSettings && appSettings.isGSTApplicable && (
              <td>₹{report.cgstFourteenPerAmt} </td>
            )}
            {appSettings && appSettings.isGSTApplicable && (
              <td>₹{report.sgstFourteenPerAmt} </td>
            )}
            {appSettings && appSettings.isGSTApplicable && (
              <td>₹{report.igstFivePerTaxableAmt}</td>
            )}
            {appSettings && appSettings.isGSTApplicable && (
              <td>₹{report.igstFivePerAmt}</td>
            )}
            {appSettings && appSettings.isGSTApplicable && (
              <td>₹{report.igstTwelvePerTaxableAmt}</td>
            )}
            {appSettings && appSettings.isGSTApplicable && (
              <td>₹{report.igstTwelvePerAmt}</td>
            )}
            {appSettings && appSettings.isGSTApplicable && (
              <td>₹{report.igstEighteenPerTaxableAmt}</td>
            )}
            {appSettings && appSettings.isGSTApplicable && (
              <td>₹{report.igstEighteenPerAmt}</td>
            )}
            {appSettings && appSettings.isGSTApplicable && (
              <td>₹{report.igstTwentyEightPerTaxableAmt}</td>
            )}
            {appSettings && appSettings.isGSTApplicable && (
              <td>₹{report.igstTwentyEightPerAmt}</td>
            )}
            <td>₹{report.otherCharges ? report.otherCharges : 0}</td>
            <td>
              <Dropdown className="DropdownMenoReport ">
                <Dropdown.Toggle
                  variant="success"
                  id="dropdown-basic"
                  className="threedotOption "
                >
                  <img src={optionIcon} alt="" />
                </Dropdown.Toggle>

                <Dropdown.Menu className="dropdownMeno22">
                  <ul className="dropdownmenulist22">
                    <li
                      onClick={() => {
                        getTaxInvoiceData(report.id, "print");
                      }}
                    >
                      Print
                    </li>
                    <li
                      onClick={() => {
                        // optionshow();
                        getTaxInvoiceData(report.id, "view");
                      }}
                    >
                      View
                    </li>
                    <li>Download</li>
                  </ul>
                </Dropdown.Menu>
              </Dropdown>
            </td>
          </tr>
        );
      });

  return (
    <div>
      <div
        id="cx-main"
        className={sidebar ? "salesReportMain" : "cx-active salesReportMain"}
      >
        <div className="role-content">
          <ReportTabs
            setSalesReport={setSalesReport}
            reportPayLoad={reportPayLoad}
            setReportPayLoad={setReportPayLoad}
            setLoading={setLoading}
          />
          <div className="d-flex justify-content-between role-searchbar-and-btns RspSalary">
            <div className="role-table-header">
              <div className="search-input-wrapper">
                <input
                  type="text"
                  placeholder="Search"
                  onChange={(e) => {
                    setSearchValue(e.target.value);
                    setCurrentPage(0);
                    setUsersPerPage(5);
                  }}
                />

                {Dark === "lightMode" ? (
                  <img src={searchicon} alt="" />
                ) : (
                  <img src={searchicon} alt="" />
                )}
              </div>
              <div className="entries-wrapper">
                <p>Entries per page</p>
                <select
                  className="form-select select-drop-icon"
                  aria-label="Default select example"
                  onChange={(e) => pageSizeHandler(e)}
                >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="15">15</option>
                  <option value="20">20</option>
                </select>
              </div>
            </div>

            <div className="role-btns-wrapper">
              {/* <button onClick={handleShow}>
                <svg
                  width="18"
                  height="16"
                  viewBox="0 0 18 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.1441 13.8031V14.7551C14.1401 14.8514 14.1163 14.9458 14.0741 15.0324C14.0319 15.119 13.9723 15.196 13.899 15.2585C13.8256 15.321 13.7402 15.3677 13.648 15.3957C13.5558 15.4237 13.4588 15.4323 13.3631 15.4211H0.929138C0.838264 15.4317 0.746169 15.4219 0.659545 15.3925C0.57292 15.3631 0.49394 15.3147 0.428344 15.2509C0.362747 15.1871 0.31218 15.1095 0.280317 15.0238C0.248454 14.938 0.236095 14.8462 0.244138 14.7551V5.3551C0.235395 5.25736 0.246286 5.15886 0.27617 5.06539C0.306054 4.97192 0.354328 4.88538 0.418152 4.81084C0.481975 4.7363 0.56006 4.67528 0.647814 4.63136C0.735567 4.58744 0.831217 4.56151 0.929138 4.5551H3.15714C3.3591 4.5551 3.55279 4.63533 3.6956 4.77814C3.83841 4.92095 3.91864 5.11464 3.91864 5.3166C3.91864 5.51857 3.83841 5.71226 3.6956 5.85507C3.55279 5.99787 3.3591 6.0781 3.15714 6.0781H1.76714V13.9021H12.6181V13.8021C12.6181 13.6001 12.6984 13.4065 12.8412 13.2636C12.984 13.1208 13.1777 13.0406 13.3796 13.0406C13.5816 13.0406 13.7753 13.1208 13.9181 13.2636C14.0609 13.4065 14.1411 13.6001 14.1411 13.8021L14.1441 13.8031ZM17.5331 6.7031L12.8121 11.5191C12.7052 11.6276 12.5684 11.7018 12.4192 11.7322C12.2699 11.7627 12.115 11.748 11.9741 11.6901C11.8288 11.6329 11.7039 11.5334 11.6157 11.4046C11.5275 11.2757 11.4799 11.1233 11.4791 10.9671V8.8911C9.95614 8.8531 6.30114 9.0051 4.96814 11.3471C4.90263 11.4669 4.80641 11.5671 4.68936 11.6374C4.57232 11.7077 4.43866 11.7456 4.30214 11.7471C4.23821 11.7502 4.17419 11.7438 4.11214 11.7281C3.94873 11.6842 3.8043 11.5878 3.70111 11.4537C3.59792 11.3196 3.54171 11.1553 3.54114 10.9861C3.59838 9.02185 4.38353 7.14896 5.74414 5.7311C7.27785 4.23876 9.33419 3.4051 11.4741 3.4081V1.3331C11.4759 1.18256 11.522 1.03587 11.6067 0.911378C11.6913 0.78688 11.8108 0.690091 11.9501 0.633103C12.094 0.574261 12.252 0.559099 12.4044 0.58951C12.5568 0.619922 12.6969 0.694559 12.8071 0.804103L17.5471 5.6201C17.6858 5.76716 17.7615 5.96249 17.7584 6.16456C17.7552 6.36662 17.6733 6.55947 17.5301 6.7021L17.5331 6.7031Z"
                    fill="#3DA298"
                  />
                </svg>
              </button> */}
              <button onClick={exportSalesReport}>
                {" "}
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12.5901 17.2281C12.5721 17.2294 12.5541 17.2294 12.5361 17.2281L3.02012 15.8691C2.84089 15.8433 2.67681 15.7542 2.55758 15.6179C2.43835 15.4816 2.37185 15.3072 2.37012 15.1261V2.86911C2.37111 2.68741 2.43725 2.5121 2.55653 2.37502C2.6758 2.23794 2.8403 2.14821 3.02012 2.12211L12.5351 0.769115C12.5885 0.761859 12.6428 0.765946 12.6945 0.78111C12.7462 0.796274 12.7941 0.822173 12.8351 0.857115C12.8759 0.892567 12.9086 0.936351 12.931 0.985515C12.9535 1.03468 12.9651 1.08808 12.9651 1.14211V16.8511C12.9646 16.9508 12.9247 17.0463 12.8541 17.1168C12.7834 17.1872 12.6879 17.2269 12.5881 17.2271L12.5901 17.2281ZM7.40912 10.4801L8.42012 12.2801H9.93912L8.17012 9.13111L9.93912 5.98511H8.42112L7.40912 7.78511L6.39712 5.98511H4.87812L6.64912 9.13111L4.87812 12.2771H6.39712L7.40812 10.4771L7.40912 10.4801ZM16.7521 15.7801H13.7241V14.2691H15.9941V3.72411H13.7241V2.21811H16.7511C16.9513 2.21785 17.1434 2.29697 17.2853 2.43813C17.4272 2.57928 17.5073 2.77096 17.5081 2.97111V15.0251C17.5076 15.2253 17.4277 15.417 17.286 15.5584C17.1443 15.6997 16.9523 15.7791 16.7521 15.7791V15.7801Z"
                    fill="#3DA298"
                  />
                </svg>
              </button>
              <Dropdown className="DropdownMenoReport">
                <Dropdown.Toggle variant="success" id="dropdown-basic">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M7 11H17V13H7V11ZM4 7H20V9H4V7ZM10 15H14V17H10V15Z"
                      fill="#3DA298"
                    />
                  </svg>
                </Dropdown.Toggle>
                <Dropdown.Menu
                  className={
                    Dark === "darkMode" ? "dropdownMeno" : "dropdownMeno2"
                  }
                  style={{ width: '200px' }}
                >
                  <img src={Up_arrow_white} alt="" className="up-img-sales" />
                  <Dropdown.ItemText>
                    <div className="topsectionReport">
                      <div className="filtermenu">Filter</div>
                      <div className="filterline"></div>
                    </div>
                  </Dropdown.ItemText>
                  <ul className="dropdownmenulist">
                    <li onClick={() => handeldate()}>By Date</li>
                    {/* <li onClick={() => compantShow()}>By Company</li> */}
                    <li
                      onClick={() => {
                        innerlist();
                      }}
                      className={active}
                    >
                      <label>Display Item</label>
                      <img src={downarrow} alt="" />
                    </li>
                    {innermenu == true ? (
                      <ul className="dropdownmenulist ">
                        <li className="innerlistrpt">
                          <input type="radio" id="radio1" name="radio-group" />
                          <label for="radio1" className="form-check-label">
                            GST
                          </label>
                        </li>
                        <li className="innerlistrpt">
                          <input
                            type="radio"
                            id="radio3"
                            claas="form-check-input"
                            name="radio-group"
                          />
                          <label for="radio3">Invoice Type</label>
                        </li>
                        <li className="innerlistrpt">
                          <input
                            type="radio"
                            id="radio4"
                            claas="form-check-input"
                            name="radio-group"
                          />
                          <label for="radio4">Other Charges</label>
                        </li>
                      </ul>
                    ) : null}

                    <li onClick={toggleMenu} className="changeViewToggle">
                      <label>Change View</label>
                      <img src={downarrow} alt="" />
                    </li>
                    {innermenu2 == true ? (
                      <ul className="dropdownmenulist option-btns">
                        <li className="innerlistrpt">
                          <input
                            type="radio"
                            id="radio5"
                            className="form-check-input"
                            name="radio-group"
                            onChange={() => getDateRange("Daily")}
                          />
                          <label for="radio5" className="form-check-label">
                            Daily
                          </label>
                        </li>
                        <li className="innerlistrpt">
                          <input
                            type="radio"
                            id="radio6"
                            name="radio-group"
                            onChange={() => getDateRange("Weekly")}
                          />
                          <label for="radio6">Weekly</label>
                        </li>
                        <li className="innerlistrpt">
                          <input
                            type="radio"
                            id="radio7"
                            name="radio-group"
                            onChange={() => getDateRange("Quarterly")}
                          />
                          <label for="radio7">Quaterly</label>
                        </li>
                        <li className="innerlistrpt">
                          <input
                            type="radio"
                            id="radio8"
                            name="radio-group"
                            onChange={() => getDateRange("Semi-Annually")}
                          />
                          <label for="radio8">Semi-Annually</label>
                        </li>
                        <li className="innerlistrpt">
                          <input
                            type="radio"
                            id="radio9"
                            name="radio-group"
                            onChange={() => getDateRange("Annually")}
                          />
                          <label for="radio9">Annually</label>
                        </li>
                      </ul>
                    ) : null}
                  </ul>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>

          {/* Cash */}

          {reportPayLoad ? (
            <div className="table-wrapper">
              {loading ? (
                <div>
                  <div className="center-spinner">
                    <BeatLoader color="#3DA298" className="spinner" />
                  </div>
                </div>
              ) : salesReport && salesReport.length > 0 ? (
                <table>
                  <tr className="firstTabelRow">
                    <th>Sr. No</th>
                    <th>Date</th>
                    <th>Particular</th>
                    <th>Voucher Type</th>

                    {/* Static data****************** */}
                    <th>Voucher Ref. No.</th>
                    {appSettings && appSettings.isGSTApplicable && (
                      <th>GSTIN/UIN</th>
                    )}

                    {/* <th>Narration</th> */}
                    <th>Gross Total</th>
                    <th>Round Off</th>
                    {/* <th>Invoice No.</th>

                    <th>E-way Bill</th>
                    <th>Basic Amt.</th>

                    <th>Amount (Inc. GST)</th> */}
                    {appSettings && appSettings.isGSTApplicable && (
                      <th>GST Sales @ 5%</th>
                    )}
                    {appSettings && appSettings.isGSTApplicable && (
                      <th>CGST Sales @ 2.5%</th>
                    )}
                    {appSettings && appSettings.isGSTApplicable && (
                      <th>SGST Sales @ 2.5%</th>
                    )}
                    {appSettings && appSettings.isGSTApplicable && (
                      <th>GST Sales @ 12%</th>
                    )}
                    {appSettings && appSettings.isGSTApplicable && (
                      <th>CGST Sales @ 6%</th>
                    )}
                    {appSettings && appSettings.isGSTApplicable && (
                      <th>SGST Sales @ 6%</th>
                    )}
                    {appSettings && appSettings.isGSTApplicable && (
                      <th>GST Sales @ 18%</th>
                    )}
                    {/* Static data****************** */}
                    {appSettings && appSettings.isGSTApplicable && (
                      <th>CGST Sales @ 9%</th>
                    )}
                    {appSettings && appSettings.isGSTApplicable && (
                      <th>SGST Sales @ 9%</th>
                    )}
                    {appSettings && appSettings.isGSTApplicable && (
                      <th>GST Sales @ 28%</th>
                    )}
                    {appSettings && appSettings.isGSTApplicable && (
                      <th>CGST Sales @ 14%</th>
                    )}
                    {appSettings && appSettings.isGSTApplicable && (
                      <th>SGST Sales @ 14%</th>
                    )}
                    {appSettings && appSettings.isGSTApplicable && (
                      <th>GST Sales @ 5%</th>
                    )}
                    {appSettings && appSettings.isGSTApplicable && (
                      <th>IGST Sales @ 5%</th>
                    )}
                    {appSettings && appSettings.isGSTApplicable && (
                      <th>GST Sales @ 12%</th>
                    )}
                    {appSettings && appSettings.isGSTApplicable && (
                      <th>IGST Sales @ 12%</th>
                    )}
                    {appSettings && appSettings.isGSTApplicable && (
                      <th>GST Sales @ 18%</th>
                    )}
                    {appSettings && appSettings.isGSTApplicable && (
                      <th>IGST Sales @ 18%</th>
                    )}
                    {appSettings && appSettings.isGSTApplicable && (
                      <th>GST Sales @ 28%</th>
                    )}
                    {appSettings && appSettings.isGSTApplicable && (
                      <th>IGST Sales @ 28%</th>
                    )}
                    <th>Other Charges</th>
                    <th>Action</th>
                  </tr>
                  {searchValue === ""
                    ? displayInvoices
                    : displaySearchedInvoices}
                </table>
              ) : (
                <NoDataFound />
              )}
            </div>
          ) : null}
        </div>

        <div className="row mt-4">
          <div className="col-lg-12">
            {!loading &&
              Math.ceil(searchedDataPageCounts?.length / usersPerPage) > 1 && (
                <ReactPaginate
                  previousLabel={"Previous"}
                  nextLabel={"Next"}
                  pageCount={
                    searchValue === ""
                      ? pageCount
                      : Math.ceil(searchedDataPageCounts?.length / usersPerPage)
                  }
                  onPageChange={changePage}
                  containerClassName={"paginationBttns"}
                  previousLinkClassName={"previousBttn"}
                  nextLinkClassName={"nextBttn"}
                  disabledClassName={"paginationDisabled"}
                  activeClassName={"paginationActive"}
                  forcePage={currentPage}
                />
              )}
          </div>
        </div>

        {/* <div className="pagination">
                <div className="pagination_btn">
                  <button>&lt;&lt;</button>
                  <button className="backgroundPagination">1</button>
                  <button>2</button>
                  <button>3</button>
                  <button>4</button>
                  <button>&gt;&gt;</button>
                </div>
                </div> */}
      </div>

      {/* salary mode */}

      <Modal
        show={show}
        onHide={handleClose}
        centered
        className="salary_model_main modal-lg"
      >
        <Modal.Header className="salary_model_header bordernone">
          <Modal.Title>
            <p className="slaarydetaiscolore">Salary Details</p>
          </Modal.Title>
          <div className="crossArrow">
            <img
              src={Dark === "darkMode" ? LightCross : DarkCross}
              alt=""
              onClick={handleClose}
            />
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="model_contain">
            <div className="overflowslarytable">
              <table className="model_tabel">
                <tr>
                  <td>Name Of Employee</td>
                  <td>Employee ID</td>
                  <td>Monthly Salary</td>
                </tr>
                <tr>
                  <th>Rohan Sharma</th>
                  <th>123456</th>
                  <th>Rs. 20,000</th>
                </tr>
                <tr>
                  <td>Payment Mode</td>
                  <td>- </td>
                  <td>- </td>
                </tr>
                <tr>
                  <th>Cash / Cheque / Online</th>
                  <th>- </th>
                  <th>- </th>
                </tr>
              </table>
            </div>
            <div className="salary_datatabel">
              <table>
                <tr>
                  <td rowspan="2">Month</td>
                  <td rowspan="2">No. of Days Present</td>
                  <td rowspan="2">Gross Salary</td>
                  <td colSpan="4">Deduction</td>
                  <td>Salary Payable </td>
                </tr>
                <tr>
                  <td>Profession Tax</td>
                  <td>Income Tax</td>
                  <td>Advance</td>
                  <td>ESIC</td>
                  <td></td>
                </tr>
                <tr>
                  <td>July</td>
                  <td>30</td>
                  <td>Rs. 20,000</td>
                  <td>Rs. 200</td>
                  <td>Rs. 200</td>
                  <td>Rs. 200</td>
                  <td>Rs. 200</td>
                  <td>Rs. 18,900</td>
                </tr>
              </table>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/*  By Date PopUp */}
      <Modal
        aria-labelledby="contained-modal-title-vcenter "
        centered
        show={date}
        className="create-workflow-main date_model_salesReport"
      >
        <Modal.Header
          closeButton
          className=" create-workflow-topbody"
          onClick={dateclose}
        >
          <Modal.Title>
            <label
              htmlFor=""
              className="create-workflow-text dtaemodel_headimg"
            >
              Date
            </label>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="row datemodel">
            <div className="col-lg-6">
              <label>From</label>
              <input
                type="date"
                onChange={(e) => setFromDate(e.target.value)}
              />
            </div>
            <div className="col-lg-6">
              <label>To</label>
              <input type="date" onChange={(e) => setToDate(e.target.value)} />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="datemodalbotton">
          <div>
            <button className="modal-cancel-btn" onClick={dateclose}>
              Cancel
            </button>

            {/* <button onClick={filterData}>Apply Filter</button> */}

            <button
              className="modal-create-btn"
              onClick={() => {
                setReportPayLoad({
                  ...reportPayLoad,
                  fromDate: fromDate,
                  toDate: toDate,
                });
                setDate(false);
              }}
            >
              Apply Filter
            </button>
            {/* Display your filtered data */}
          </div>
        </Modal.Footer>
      </Modal>

      {/* Company modal popup */}
      <Modal
        aria-labelledby="contained-modal-title-vcenter "
        centered
        show={company}
        className="create-workflow-main date_model_salesReport"
      >
        <Modal.Header
          className=" create-workflow-topbody"
          onClick={companyClose}
        >
          <Modal.Title>
            <label
              htmlFor=""
              className="create-workflow-text dtaemodel_headimg"
            >
              Company Name
            </label>
          </Modal.Title>
          <div className="crossArrow">
            <img
              src={Dark === "darkMode" ? LightCross : DarkCross}
              alt=""
              onClick={handleClose}
            />
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="row">
            <div className="companyModelMain ">
              <p>From</p>
              <select
                className="form-select select-drop-icon componymodelDrop"
                aria-label="Default select example"
              >
                <option selected>Enter Company Name</option>
                <option value="1">20</option>
                <option value="2">10</option>
                <option value="3">5</option>
              </select>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="datemodalbotton">
          <div>
            <button className="modal-cancel-btn" onClick={companyClose}>
              Cancel
            </button>
            <button className="modal-create-btn">Apply Filter</button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* viwe details modal */}
      {/* <Modal
        aria-labelledby="contained-modal-title-vcenter "
        centered
        show={option}
        className="create-workflow-main incoive_details_model_main modal-xl"
      >
        <Modal.Header
          closeButton
          className=" create-workflow-topbody"
          onClick={optionshow}
        >
          <Modal.Title>
            <label
              htmlFor=""
              className="create-workflow-text dtaemodel_headimg"
            >
              Invoice Details
            </label>
          </Modal.Title>
        </Modal.Header>

         <Modal.Body>
          <div className="row invoice_upper_section">
            <div className="col-lg-4 col-sm-6 invoice_Upper_tabal">
               <label>Invoice NO</label>
              <h3>ABCD1234</h3>
            </div>
            <div className="col-lg-4 col-sm-6 invoice_Upper_tabal">
              <label>Invoice Type.</label>
              <h3>
                Sales <span>Cash</span>
              </h3>
            </div> 
             <div className="col-lg-4 invoice_Upper_tabal"> 
              <label>Date </label>
              <h3>06-06-2022</h3>
            </div>
            <div className="col-lg-4 col-sm-6 invoice_Upper_tabal">
              <label>Name Of Customer/Party </label>
              <h3>Redbytes Software. Pvt. Ltd</h3>
            </div>
            <div className="col-lg-4 col-sm-6 invoice_Upper_tabal">
              <label>Current Invoice</label>
              <h3>Rs.24,00,000.00</h3>
            </div>
            <div className="col-lg-4 col-sm-6 invoice_Upper_tabal">
              <label>Invoice Amount</label>
              <h3>Rs.24,00,000.00</h3>
            </div> 
          </div>

           <div className="invoice_tabel">
            <table>
              <tr>
                <td>Particular</td>
                <td>Address</td>
                <td>E-way Bill</td>
                <td>Sales Export Amt.</td>
                <td>Sales Indigenous</td>
                <td>CGST</td>
                <td>SGST</td>
              </tr>
              <tr>
                <td>Accounting and Bookeeping Service</td>{" "}
                <td>
                  125/2, Sainiketan Colony, kalas Road, Visharant Wadi, Pune,
                  Maharashtra 411015
                </td>
                <td>32547896</td>
                <td>Rs. 24,00,000.00</td>
                <td>XYZ</td>
                <td>Rs.900.00</td>
                <td>Rs.900.00</td>
              </tr>
            </table>
          </div> 
        </Modal.Body>
          </Modal> */}

      <GoodsInvoiceView
        previewTaxInvoiceData={previewTaxInvoiceData}
        isView={isView}
        setIsView={setIsView}
        previewLoader={previewLoader}
      />
      <GoodsPrintView
        previewTaxInvoiceData={previewTaxInvoiceData}
        printModal={printModal}
        setPrintModal={setPrintModal}
        print={print}
        setPrint={setPrint}
      />
    </div>
  );
};

export default SalseReport;
